import React from 'react';
import BubbleChartWrap from './bubble-chart/BubbleChartWrap';
import BarChartWrap from './bar-chart/BarChartWrap';
import { connect } from 'react-redux';
import { fetchDataContribution, REDUCER_NAME } from '../reducer';
import ChartHead from './ChartHead';
import Loading from './../../../../common/loading/Loading';
import LabelLeftRight from '../../../../common/chart/label/LabelLeftRight';
import LabelFooter from './bubble-chart/LabelFooter';
import { Translate } from 'react-redux-i18n';
import currentState from './../../../../helpers/CurrentState';
import ConstCommon from './../../../../common/Const';

const MIN_WIDTH = 600;
const CHART_HEIGHT = 300;
const CHART_HEAD_HEIGHT = 50;
const CHART_FOOTER_HEIGHT = 30;
const INTERVAL_TIME = 30000;

class Chart extends React.Component {
  constructor(props) {
    super(props);
    const isShowBarChart = currentState.get(
      ConstCommon.listComponent.MoneyFlow,
      'isShowBarChart',
    );

    this.state = {
      isShowBarChart: isShowBarChart !== undefined ? isShowBarChart : true,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchDataContribution());
    this.interval = setInterval(() => {
      dispatch(fetchDataContribution());
    }, INTERVAL_TIME);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  toggleShowBarChart = () => {
    const isShowBarChart = !this.state.isShowBarChart;
    currentState.add(
      ConstCommon.listComponent.MoneyFlow,
      'isShowBarChart',
      isShowBarChart,
    );
    this.setState({ isShowBarChart });
  };

  getWidth = component => {
    return Math.max(component.width - 40, MIN_WIDTH);
  };

  getHeight = () => {
    return CHART_HEIGHT + CHART_HEAD_HEIGHT + CHART_FOOTER_HEIGHT;
  };

  render() {
    const { data, component, isFetching } = this.props;
    const { isShowBarChart } = this.state;

    return (
      <div
        className="position-relative"
        style={{
          width: this.getWidth(component),
          height: this.getHeight(),
        }}
      >
        {isFetching && <Loading />}
        <div className={isFetching ? 'bg-blur' : ''}>
          {data && data.length > 0 ? (
            <div className="money-flow-chart stock-chart">
              <div style={{ height: CHART_HEAD_HEIGHT }}>
                <ChartHead
                  toggleShowBarChart={this.toggleShowBarChart}
                  isShowBarChart={isShowBarChart}
                />
              </div>
              <div className="position-relative pl-10 pr-10">
                <LabelLeftRight
                  text={'moneyFlowContribution.LABEL_CHART_LEFT'}
                />
                <div>
                  {isShowBarChart ? (
                    <BarChartWrap
                      data={data}
                      ratio={window.devicePixelRatio}
                      width={this.getWidth(component)}
                      height={CHART_HEIGHT}
                    />
                  ) : (
                    <BubbleChartWrap
                      data={data}
                      ratio={window.devicePixelRatio}
                      width={this.getWidth(component)}
                      height={CHART_HEIGHT}
                    />
                  )}
                </div>
              </div>
              <div style={{ height: CHART_FOOTER_HEIGHT }}>
                {isShowBarChart || <LabelFooter />}
              </div>
            </div>
          ) : (
            !isFetching && (
              <div className="p-20">
                <Translate value={'common.NO_DATA'} />
              </div>
            )
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    data: state[REDUCER_NAME].contributionDataFollowTimeRange,
    component: state[REDUCER_NAME].component,
    isFetching: state[REDUCER_NAME].isFetching,
  };
};

export default connect(mapStateToProps)(Chart);
